import React from 'react';
import './Service3.css';
import about3 from '../Imges/Approach.png';

const Second = () => {
  return (
    <div className="meet-our-clients">
      <h2 className="section-title" style={{marginTop:'50px'}}>
        <span className="title-bar" >|</span> OUR APPROACH <span className="title-bar">|</span>
      </h2>

      <div className="capabilities-containerrr" >
        <div className="capabilities-content"  style={{marginTop:'120px'}}>
          <div className="capabilities-image">
            <img src={about3} alt="Creative Workspace" />
          </div>

          <div className="capabilities-text">
            <h2 style={{textAlign:'left'}}>
              <strong>MEASURABLE, NEEDLE-MOVING GROWTH DOES NOT HAPPEN OVERNIGHT. THERE'S A METHOD TO OUR METICULOUSNESS.</strong>
            </h2>
            <p>
              In order for branding efforts to be truly effective, they must be well-thought-out and precisely executed – but more than that – they must be customized for your company, and designed with your industry, competitors and customers in mind.
            </p>
            <p>
              In order for branding efforts to be truly effective, they must be well-thought-out and precisely executed – but more than that – they must be customized for your company, and designed with your industry, competitors and customers in mind.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Second;
